import React, { useRef, useEffect } from "react";


// ... (AutoResizeTextarea Component stays the same) ...
export const AutoResizeTextarea = ({ value, onChange, placeholder, minLines = 3, className }: any) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const adjustHeight = () => {
        const textarea = textareaRef.current;
        if (!textarea) return;
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    };
    useEffect(() => { adjustHeight(); }, [value]);

    return (
        <textarea
            ref={textareaRef}
            className={className}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            rows={minLines} />
    );
};
